export const ru = {
    choose: 'Выбрать'
};
